import { Component, Inject, OnInit } from '@angular/core';
import { ConfirmationType } from 'app/core/models/confirmation-type.enum';
import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'biz-action-confirmation',
  templateUrl: './action-confirmation.component.html',
  styleUrls: ['./action-confirmation.component.scss']
})
export class ActionConfirmationComponent implements OnInit {

  constructor(
    public modalComponentRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public data: { message: string, title: string, type: ConfirmationType, button?: string, cancelButton?: string, disabledColorButton?: boolean }
  ) { }

  ngOnInit(): void {
  }


  close() {
    this.modalComponentRef.close();
  }

  confirmation() {
    this.modalComponentRef.close(this.data.type);
  }

  get isConfirmation() {
    return this.data.type === ConfirmationType.CONFIRMATION;
  }

  get isDisabledColorButton() {
    return this.data.disabledColorButton;
  }

}
